@if(mapsApiService.isApiLoaded$ | async) {
<google-map
  #googleMap
  id="googleMap"
  [center]="center"
  [zoom]="_zoom()"
  [options]="mapOptions"
  [mapTypeId]="mapTypeId()"
  (mapClick)="mapClick.emit()"
  (boundsChanged)="boundsChanged()"
  (centerChanged)="centerChanged()"
  (zoomChanged)="getAndEmitChangedZoom()"
  width="100%"
  height="100%"
>
  @if(isDebug()) {
  <!-- rectangles for each tile -->
  @for(tile of visibleTiles()?.tiles; track tile) {
  <map-rectangle
    [bounds]="
      getBoundsForTile({ zoom: visibleTiles()!.zoom, x: tile.x, y: tile.y })
    "
    [options]="{
      strokeColor: '#FF0000',
      strokeOpacity: 0.7,
      strokeWeight: 1,
      fillOpacity: 0
    }"
  ></map-rectangle>
  }

  <!-- Debug: Rendering bounds -->
  <map-rectangle
    [bounds]="boundsToRender()!"
    [options]="{
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillOpacity: 0
    }"
  ></map-rectangle>

  <!-- Debug zoom level -->
  <div
    style="
      color: white;
      background-color: red;
      position: absolute;
      bottom: 20px;
      right: 20px;
      padding: 10px;
    "
  >
    Debug Mode: Zoom {{ zoom }}, sw: ({{ visibleTiles()!.sw.x }},
    {{ visibleTiles()!.sw.y }}), ne: ({{ visibleTiles()!.ne.x }},
    {{ visibleTiles()!.ne.y }})
  </div>

  }

  <!-- Cluster Markers -->
  @for (dot of dots; track $index) {
  <div
    #smallDot
    class="small-dot-marker"
    [ngClass]="{
      'marker-primary-dark': isDarkMode,
      'marker-primary-light': !isDarkMode
    }"
    [style]="{
      height: 12 + sqrt(dot.weight) * 3 + 'px',
      width: 12 + sqrt(dot.weight) * 3 + 'px'
    }"
  ></div>
  <map-advanced-marker
    [position]="geopointToLatLngLiteral(dot.location)"
    [content]="smallDot"
    (mapClick)="clickDot(dot)"
    [zIndex]="dot.weight"
  ></map-advanced-marker>
  }

  <!-- only display the bounds when close enough (zoom >= 16) -->
  @if (zoom >= 16) { @for(spot of spots; track $index) { @if(!spot?.hasBounds())
  {
  <map-circle
    [center]="spot.location()"
    [radius]="10"
    [options]="spotCircleOptions"
    (circleClick)="spotClick.emit(spot)"
  >
  </map-circle>
  } @else {
  <map-polygon
    [options]="spotPolygonOptions"
    [paths]="spot.paths![0]"
    (polygonClick)="spotClick.emit(spot)"
  ></map-polygon>
  } } }
  <!-- selected spot marker -->
  @if(selectedSpot) { @if(showSpotPreview()) {
  <map-advanced-marker
    #selectedSpotMarker
    id="selectedSpotMarker"
    [position]="selectedSpot.location()"
    [draggable]="isEditing"
    (mapDragend)="editingSpotPositionChanged($event.latLng!)"
    [content]="selectedSpotInfoWindow"
    [zIndex]="1000000 + 1"
  ></map-advanced-marker>
  <div
    #selectedSpotInfoWindow
    class="marker-info-window fade-in d-flex flex-column align-items-center"
    style="width: 200px"
  >
    <app-spot-preview-card
      [spot]="selectedSpot"
      [hasBorder]="false"
      (dismiss)="selectedSpot = null"
      class="shadow-lg flex-grow-1 w-100"
    >
    </app-spot-preview-card>
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="var(--mdc-elevated-card-container-color, var(--mat-sys-surface-container-low))"
      xmlns="http://www.w3.org/2000/svg"
      style="margin-top: -7px"
    >
      <path
        d="M6.88614 10.6061C7.4508 11.2455 7.73313 11.5653 8.04116 11.7336C8.63871 12.06 9.36129 12.06 9.95884 11.7336C10.2669 11.5653 10.5492 11.2455 11.1139 10.6061L16.1201 4.93655C17.1337 3.78859 17.6406 3.21461 17.7605 2.75071C17.9955 1.84214 17.5671 0.8924 16.7305 0.467134C16.3034 0.25 15.5377 0.25 14.0062 0.25H3.99378C2.46234 0.25 1.69663 0.25 1.26948 0.467134C0.432911 0.8924 0.00453424 1.84214 0.239482 2.75071C0.359444 3.21461 0.86627 3.78859 1.87992 4.93655L6.88614 10.6061Z"
      />
    </svg>
  </div>
  } @else {
  <map-advanced-marker
    #selectedSpotMarker
    id="selectedSpotMarker"
    [position]="selectedSpot.location()"
    [draggable]="isEditing"
    (mapDragend)="editingSpotPositionChanged($event.latLng!)"
    [content]="selectedSpotMarkerNode.elementRef.nativeElement"
    [zIndex]="1000000 + 1"
    [options]="{
      gmpDraggable: isEditing
    }"
  ></map-advanced-marker>
  <app-marker
    #selectedSpotMarkerNode
    class="fade-in"
    id="selectedSpotMarkerNode"
    [icons]="[selectedSpot.isIconic ? 'star' : 'directions_run']"
    [isIconic]="selectedSpot.isIconic"
  >
  </app-marker>
  } }

  <!-- <map-advanced-marker
    *ngIf="selectedSpot"
    #selectedSpotMarker
    className="'spot-marker'"
    id="selectedSpotMarker"
    [options]="
      isEditing ? selectedSpotMarkerEditingOptions : selectedSpotMarkerOptions
    "
    [position]="selectedSpot.location"
    (mapDragend)="editingSpotPositionChanged($event.latLng)"
  ></map-advanced-marker> -->

  <!-- Highlighted spot markers
  @for(spot of highlightedSpots; track spot) {
  <map-advanced-marker
    #selectedSpotMarker
    id="selectedSpotMarker"
    [position]="spot.location"
    [options]="{
      gmpDraggable: true
    }"
    (mapDragend)="editingSpotPositionChanged($event.latLng)"
    [content]="selectedSpotMarkerNode"
  ></map-advanced-marker> -->
  <!-- <div
    class="pin-marker"
    #selectedSpotMarkerNode
    id="selectedSpotMarkerNode"
    [rating]="spot.rating"
  >
    <div class="mat-label-large pin-primary">
      <mat-icon style="height: 20px; font-size: 20px; width: 20px"
        >star</mat-icon
      >
    </div>
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.88614 10.6061C7.4508 11.2455 7.73313 11.5653 8.04116 11.7336C8.63871 12.06 9.36129 12.06 9.95884 11.7336C10.2669 11.5653 10.5492 11.2455 11.1139 10.6061L16.1201 4.93655C17.1337 3.78859 17.6406 3.21461 17.7605 2.75071C17.9955 1.84214 17.5671 0.8924 16.7305 0.467134C16.3034 0.25 15.5377 0.25 14.0062 0.25H3.99378C2.46234 0.25 1.69663 0.25 1.26948 0.467134C0.432911 0.8924 0.00453424 1.84214 0.239482 2.75071C0.359444 3.21461 0.86627 3.78859 1.87992 4.93655L6.88614 10.6061Z"
        fill="#DDE1FF"
      />
    </svg>
  </div> } -->

  <!-- Geolocation -->
  @if(showGeolocation && geolocation()) {
  <div #geolocationMarker class="geolocation-marker"></div>
  <map-advanced-marker
    [position]="geolocation()!.location"
    [content]="geolocationMarker"
    [zIndex]="1000000"
  >
  </map-advanced-marker>
  <map-circle
    [center]="geolocation()!.location"
    [radius]="geolocation()!.accuracy"
    [options]="geolocationCircleOptions"
  ></map-circle>
  }

  <!-- Additional Markers -->
  @for(marker of markers(); track $index) {
  <map-advanced-marker
    [position]="marker.location"
    [content]="markerComp.elementRef.nativeElement"
    [options]="{
      gmpClickable: true
    }"
    (mapClick)="focusOnLocation(marker.location)"
  ></map-advanced-marker>
  <app-marker
    #markerComp
    class="fade-in"
    style="pointer-events: none"
    [icons]="marker.icons"
    [number]="marker.number"
    [color]="marker.color ?? 'primary'"
    [size]="0.8"
  >
  </app-marker>
  }

  <!-- Additional Polygons -->
  @for(polygon of polygons(); track $index) {
  <map-polygon [options]="polygon" [paths]="polygon.paths"></map-polygon>
  }
</google-map>
}
